<p-confirmDialog id="bi-confirm-dialog" [focusTrap]="true" defaultFocus="none" [closable]="false" #dialog>
  <ng-template #header>
    <span class="p-dialog-title" role="presentation" id="bi_confirm_dialog" [innerHTML]="dialog.confirmation?.header"></span>

    <div class="p-dialog-header-icons">
      <p-button
        styleClass="p-dialog-header-icon p-dialog-header-close"
        [autofocus]="true"
        [rounded]="true"
        [tabindex]="0"
        [link]="true"
        icon="pi pi-times"
        [ariaLabel]="'accessibility.CloseDialog' | translate"
        (onClick)="dialog.close()"
      />
    </div>
  </ng-template>

  <ng-template #message let-message>
    <p class="text-center bi-confirm-dialog-message mx-auto" [innerHTML]="message?.message | htmlSanitize"></p>
  </ng-template>

  <ng-template #footer>
    <div class="w-full flex flex-column sm:flex-row gap-2 sm:justify-content-center bi-dialog-footer-buttons-container">
      <p-button
        *ngIf="dialog.confirmation?.acceptVisible"
        class="w-full sm:w-4"
        [label]="dialog.confirmation?.acceptLabel"
        [styleClass]="dialog.confirmation?.acceptButtonStyleClass + ' w-full'"
        (click)="dialog.onAccept()"
      />
      <p-button
        *ngIf="dialog.confirmation?.rejectVisible"
        class="w-full sm:w-4"
        [label]="dialog.confirmation?.rejectLabel"
        styleClass="w-full"
        severity="secondary"
        (click)="confirmationService.close()"
      />
    </div>
  </ng-template>
</p-confirmDialog>
